import {endpoints, types} from 'main/tools';
import {observer} from 'mobx-react';
import FilterComponent from 'main/components/tables/interactive/components/fancy_filter/filter_selector/FilterComponent';
import useFetchModels from 'shared/hooks/useFetchModels';

const ReviewCycle = observer(({filter, filterKey, filterUpdated, filterDeleted, Wrapper}) => {
  const [models, isLoading] = useFetchModels(endpoints.PERFORMANCE_REVIEWS.CYCLES.LAUNCHED, types.PERFORMANCE_REVIEWS.CYCLE);
  const options = models.map(cycle => ({ label: cycle.name, value: cycle.id }));

  return <FilterComponent
    filter={filter}
    filterKey={filterKey}
    options={options}
    filterUpdated={filterUpdated}
    filterDeleted={filterDeleted}
    Wrapper={Wrapper}
    isLoading={isLoading}
    searchable
  />;
});

export default ReviewCycle;
